import Constants from "../constants/constants";
import { ServerAPI } from "../actions/serverAPI";
import { dispatcher } from "../dispatcher/dispatcher";
import { schematicStore } from "../stores/schematic";
import { userStore } from "../stores/user";
import { formValidation } from "../util/formValidation";

const { ActionTypes, RestrictionTypes } = Constants;

var fieldsThatRefreshSchematic = Constants.fieldsThatRefreshSchematic;
var mpRegexNoDecimal = new RegExp(formValidation.regex.mpRegexNoDecimal);
var mpRegexNoLeadingDecimal = new RegExp(
  formValidation.regex.mpRegexNoLeadingDecimal
);

export const FormRequestActions = {
  /**
   * Action called when a formB field is blurred
   * @param restriction the current state of the form
   * @param id the id of the field being blurred
   */
  formFieldBlurred: function (restriction, id) {
    //render the restriction to the schematic
    if (
      (restriction.type === "A" || restriction.type === "B") &&
      fieldsThatRefreshSchematic.indexOf(id) > -1
    ) {
      dispatcher.dispatch({
        type: ActionTypes.UPDATE_SCHEMATIC_FROM_TEXT,
        restriction: restriction,
      });
      this.calculateTracks(restriction);
    }
    dispatcher.dispatch({
      type: ActionTypes.FORM_FIELD_BLURRED,
      fieldId: id,
      restriction: restriction,
    });
  },

  formFieldChanged: function (restriction, id, skipDirty) {
    dispatcher.dispatch({
      type: ActionTypes.FORM_FIELD_CHANGED,
      fieldId: id,
      restriction: restriction,
      skipDirty
    });
  },

  dateFieldChanged: function (restriction, id, dateVal) {
    var typeVal = "";
    if (id === "workStartDate") {
      typeVal = ActionTypes.WORK_START_DATE_CHANGED;
    } else if (id === "workEndDate") {
      typeVal = ActionTypes.WORK_END_DATE_CHANGED;
    } else if (id === "expectedExpireDate") {
      typeVal = ActionTypes.EXPIRE_DATE_CHANGED;
    } else if (id === "effectiveDate") {
      typeVal = ActionTypes.EFFECTIVE_DATE_CHANGED;
    } else if (id === "estimatedRemovalDate") {
      typeVal = ActionTypes.ESTIMATED_REMOVAL_DATE_CHANGED;
    }
    dispatcher.dispatch({
      type: typeVal,
      fieldId: id,
      restriction: restriction,
      date: dateVal,
    });
  },
  isWeatherRequest: function (form) {
    const { weatherWarningKey } = window.gritConfig;
    if (!weatherWarningKey || !form) return;
    return form.type === RestrictionTypes.A
      && String(form.reasonDescription).startsWith(weatherWarningKey);
  },
  checkWeatherForm: function (form) {
    if (FormRequestActions.isWeatherRequest(form)) {
      dispatcher.dispatch({
        type: ActionTypes.TOGGLE_HIDE_ACTION_BUTTONS,
        hideButtons: false
      })
      FormRequestActions.toggleModifyClicked(true);
    }
  },
  calculateTracks: function (restriction, openingItem = false) {
    let mpChange = schematicStore.didMpEntryChange();

    if (restriction.workStartMp !== "" && restriction.workEndMp !== "") {
      if (mpChange || openingItem) {
        //Check if the MP fields have changed or if this is an item we are opening
        if (mpRegexNoDecimal.test(restriction.workStartMp)) {
          restriction.workStartMp = restriction.workStartMp + ".0";
        }
        if (mpRegexNoDecimal.test(restriction.workEndMp)) {
          restriction.workEndMp = restriction.workEndMp + ".0";
        }
        if (mpRegexNoLeadingDecimal.test(restriction.workStartMp)) {
          restriction.workStartMp = "0" + restriction.workStartMp;
        }
        if (mpRegexNoLeadingDecimal.test(restriction.workEndMp)) {
          restriction.workEndMp = "0" + restriction.workEndMp;
        }

        dispatcher.dispatch({
          type: ActionTypes.SERVER_CALCULATING_GUIDS,
        });
        var calc = ServerAPI.calculateTracks(restriction);
        calc
          .done(function success(data) {
            if (data.success) {
              if (!data.data.showDefaultTracks) {
                dispatcher.dispatch({
                  type: ActionTypes.SERVER_CALCULATED_GUIDS,
                  data: data.data,
                });
              } else {
                var msg = "Contact the appropriate dispatcher.";
                if (
                  userStore
                    .getSelectedRole()
                    .indexOf(Constants.Roles.DISPATCHER) > -1
                ) {
                  msg = "Contact the system ACD.";
                }
                dispatcher.dispatch({
                  type: ActionTypes.SERVER_GUID_ERROR,
                  message: "Mps not connected. Override Required. " + msg,
                });
              }
            } else {
              FormRequestActions.checkWeatherForm(restriction);
              dispatcher.dispatch({
                type: ActionTypes.SERVER_GUID_ERROR,
                message: data.errors[0].message,
              });
            }
          })
          .fail(function (xhr, status, error) {
            FormRequestActions.checkWeatherForm(restriction);

            //throw some error
            dispatcher.dispatch({
              type: ActionTypes.SERVER_GUID_ERROR,
              message: "Call to Calculate Tracks failed: " + error,
            });
          });
      }
    } else {
      restriction.tracks = []; //Need to manually purge the tracks so that checked tracks don't get carried back to the form
      //Dispatch a blank track list since there are not two mileposts
      dispatcher.dispatch({
        type: ActionTypes.SCHEMATIC_UPDATE_COMPLETE,
        tracks: [],
        guids: [],
        excludedGuids: [],
        clearSelectedTracks: true,
      });
    }
  },

  /**
   * Action fired when a formb track checkbox is changed (checked or unchecked)
   * @param id
   * @param checked
   */
  trackSelectChanged: function (id, checked) {
    dispatcher.dispatch({
      type: ActionTypes.TRACK_SELECTION_CHANGED,
      trackId: id,
      checked: checked,
    });
  },

  /**
   * Action called when a select (drop down list) value is changed
   * @param field
   * @param value
   */
  selectChanged: function (field, value) {
    dispatcher.dispatch({
      type: ActionTypes.SELECT_CHANGED,
      field: field,
      value: value,
    });
  },

  reasonChanged: function (reason, reasonText) {
    dispatcher.dispatch({
      type: ActionTypes.REASON_CHANGED,
      reason: reason,
      text: reasonText,
    });
  },

  noFlagsChanged: function (field, value) {
    dispatcher.dispatch({
      type: ActionTypes.NO_FLAGS_CHANGED,
      field: field,
      value: value,
    });
  },

  toggleModifyClicked: function (value) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_MODIFY_REQUEST_MODE,
      value: value,
    });
  },

  defaultTracksChanged: function (field, value) {
    dispatcher.dispatch({
      type: ActionTypes.SHOW_DEFAULT_TRACKS_VALUE_CHANGED,
      field: field,
      value: value,
    });
  },

  getDefaultTracksFromServer: function () {
    var tracksCall = ServerAPI.getDefaultTracks();
    var defaultTracks = [];

    tracksCall
      .done(function (data) {
        //set the default tracks variable...
        if (data.success) {
          defaultTracks = data.data.map(function (tr) {
            return tr.name;
          });
          dispatcher.dispatch({
            type: ActionTypes.RETRIEVED_DEFAULT_TRACKS,
            tracks: defaultTracks,
          });
        }
      })
      .fail(function (status) {
        //throw some error
        console.log(status);
      });
  },

  /**
   * Resets the Form B to it's initial state
   */
  reset: function () {
    dispatcher.dispatch({
      type: ActionTypes.RESET_FORM_B_RESTRICTION,
    });
  },

  /**
   * Action called when the comment modal is closed, saves the comments
   * @param comments
   */
  commentModalClosed: function (comments) {
    dispatcher.dispatch({
      type: ActionTypes.COMMENT_MODAL_CLOSED,
      comments: comments,
    });
  },

  /**
   * Action called when the comment modal is closed
   * @param isCommentOpened
   */
  commentModalOpened: function (isCommentOpened) {
    dispatcher.dispatch({
      type: ActionTypes.COMMENT_MODAL_OPENED,
      isCommentOpened: isCommentOpened,
    });
  },

  /**
   * Action called when the bordering flag modal is closed
   * @param flags
   */
  borderingFlagModalClosed: function (flags) {
    dispatcher.dispatch({
      type: ActionTypes.BORDERING_FLAG_MODAL_CLOSED,
      flags: flags,
    });
  },

  resetSchematicToUnmodifiedText: function (req) {
    dispatcher.dispatch({
      type: ActionTypes.RESET_REQUEST_INFO,
      request: req,
    });
  },

  requestSubdivisionLocations: function (sub) {
    dispatcher.dispatch({
      type: ActionTypes.SUBDIVISION_LOCATIONS_LOADING,
    });

    let call = ServerAPI.getSubdivisionLocations(sub);
    call
      .done(function success(data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.SUBDIVISION_LOCATIONS_LOADED,
            data: data.data,
          });
        }
      })
      .fail(function (data) {
        //throw some error
        dispatcher.dispatch({
          type: ActionTypes.ERROR_OCCURRED,
          message:
            "Call to get subdivision locations for " + sub + " failed: " + data,
        });
        console.log(
          "Call to get subdivision locations for " + sub + " failed: " + data
        );
      });
  },

  requestPatternList: function () {
    ServerAPI.getPatternMaintenance()
      .done(function success(data) {
        if (data.success) {
          dispatcher.dispatch({
            type: ActionTypes.PATTERN_LIST_LOADED,
            data: data.data,
          });
        }
      })
      .fail(function (data) {
        //throw some error
        dispatcher.dispatch({
          type: ActionTypes.ERROR_OCCURRED,
          message: "Call to get patterns failed: " + data,
        });
        console.log("Call to get patterns failed: " + data);
      });
  },

  toggleShowFormCFromLocations: function (show) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_SHOW_FORM_C_FROM_LOCATIONS,
      flag: show,
    });
  },

  toggleShowFormTCMFromLocations: function (show) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_SHOW_FORM_TCM_FROM_LOCATIONS,
      flag: show,
    });
  },

  toggleShowFormCToLocations: function (show) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_SHOW_FORM_C_TO_LOCATIONS,
      flag: show,
    });
  },

  toggleShowFormTCMToLocations: function (show) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_SHOW_FORM_TCM_TO_LOCATIONS,
      flag: show,
    });
  },

  formCSubdivisionSelection: function (sub) {
    dispatcher.dispatch({
      type: ActionTypes.FORM_C_SUBDIVISION_SELECTED,
      sub: sub,
    });
  },

  formCDivisionSelection: function (div) {
    dispatcher.dispatch({
      type: ActionTypes.FORM_C_DIVISION_SELECTED,
      division: div,
    });
  },

  formCLocationSelection: function (type, location) {
    dispatcher.dispatch({
      type: ActionTypes.FORM_C_LOCATION_SELECTED,
      locationType: type,
      location: location,
    });
  },

  toggleShowSubDropDown: function (value) {
    dispatcher.dispatch({
      type: ActionTypes.TOGGLE_SHOW_SUB_DROPDOWN,
      show: value,
    });
  },

  tcmConditionPermanentChange: function (value) {
    dispatcher.dispatch({
      type: ActionTypes.TCM_COND_PERM_CHANGED,
      value: value,
    });
  },

  tcmPrintChange: function (value) {
    dispatcher.dispatch({
      type: ActionTypes.TCM_PRINT_CHANGE,
      value: value,
    });
  },

  formCTextChanged: function (text) {
    let safeString = text //Certain characters (smart quotes and dash) can not be processed by the MQ message, so we need to filter them out
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[\u2013]/g, "-");
    dispatcher.dispatch({
      type: ActionTypes.FORM_C_TEXT_CHANGED,
      text: safeString,
    });
  },

  tcmTextChanged: function (text) {
    let safeString = text
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[\u2013]/g, "-");
    dispatcher.dispatch({
      type: ActionTypes.TCM_TEXT_CHANGED,
      text: safeString,
    });
  },
};
